import {
  buildPaymentSummaryQuery,
  hasRequiredFilterKeys,
  paymentSummaryCardsFromResponse,
} from "@/components/receipt-payment-summary/payment-summary-factory";
import type {
  PaymentSummaryCardView,
  PaymentSummaryResponse,
} from "@/components/receipt-payment-summary/types";

export const SABIL_SUMMARY_QUERY_KEYS = [
  "startDate",
  "endDate",
  "paymentMode",
  "sabilId",
  "sabilType",
  "q",
] as const;

export type SabilSummaryQueryKey = (typeof SABIL_SUMMARY_QUERY_KEYS)[number];

export const SABIL_PAYMENT_SUMMARY_PATH = "sabilReceipt/summary/payment-mode";

/** Date keys that must both be set before the summary request runs. */
export const SABIL_SUMMARY_REQUIRED_DATE_KEYS = ["startDate", "endDate"] as const;

export function buildSabilSummaryQuery(filterValues: Record<string, unknown>): URLSearchParams {
  return buildPaymentSummaryQuery(filterValues, SABIL_SUMMARY_QUERY_KEYS);
}

export function shouldFetchSabilPaymentSummary(filterValues: Record<string, unknown>): boolean {
  return hasRequiredFilterKeys(filterValues, SABIL_SUMMARY_REQUIRED_DATE_KEYS);
}

/** Maps API summary JSON to the card labels/amounts rendered in the list. */
export function sabilPaymentSummaryCardsFromResponse(
  summary: PaymentSummaryResponse
): PaymentSummaryCardView[] {
  return paymentSummaryCardsFromResponse(summary);
}
